// import node module libraries
import { Alert, Button, Col, Form, Row } from 'react-bootstrap';
import Select from 'react-select';

// import custom components
// import bootstrap icons
import { ExclamationTriangleFill } from 'react-bootstrap-icons';
import { useEffect, useState } from 'react';
import DepenserecetteService from '../../services/DepenserecetteService';
import PersonnelService from '../../services/PersonnelService';

const OffcanvasAddDepenserecetteForm = ({ onClick }) => {
	const [validated, setValidated] = useState(false);
	const [feedbackMessages, setFeedbackMessages] = useState({});
	const [showAlert, setShowAlert] = useState(false);
	const [alertMessage, setAlertMessage] = useState('');
	const [PersonnelOptions, setPersonnelOptions] = useState([]);

	const TYPE_CHOICES = [
		{ value: 'depense', label: 'Depense' },
		{ value: 'recette', label: 'Recette' }
	];

	useEffect(() => {
		const fetchPersonnelOptions = async () => {
			try {
				const Personnels = await PersonnelService.getPersonnelOptions();
				setPersonnelOptions(Personnels);
			} catch (error) {
				console.error('Error fetching class options', error);
			}
		};

		fetchPersonnelOptions();
	}, []);

	const Personnel_CHOICES = PersonnelOptions;

	const handleSubmit = async (event) => {
		event.preventDefault();
		const form = event.currentTarget;

		if (form.checkValidity() === false) {
			event.stopPropagation();
		} else {
			try {
				const depenserecetteData = new FormData();

				// Add all your form data to the FormData
				depenserecetteData.append('categorie', form.categorie.value);
				depenserecetteData.append('description', form.description.value);
				depenserecetteData.append('reference', form.reference.value);
				depenserecetteData.append('personnel', form.personnel.value);
				depenserecetteData.append('date', form.date.value);
				depenserecetteData.append('fournisseur', form.fournisseur.value);
				depenserecetteData.append('montant', form.montant.value);
				depenserecetteData.append('type', form.type.value);

				// Call the DepenserecetteService to create the Depenserecette
				const response = await DepenserecetteService.createDepenserecette(
					depenserecetteData
				);

				// Reset the form and state variables after successful creation
				form.reset();
				setValidated(false);
				setFeedbackMessages({});

				// Redirect the user to the list of Depenserecettes
				window.location.href = '/finances/bilan';
			} catch (error) {
				console.error('Erreur lors de la création du bilan', error);

				if (error.response && error.response.data) {
					const apiErrors = error.response.data;

					// If there are field-specific errors
					if (typeof apiErrors === 'object' && !Array.isArray(apiErrors)) {
						const newFeedbackMessages = {};

						for (const field in apiErrors) {
							newFeedbackMessages[field] = apiErrors[field][0];
						}

						setFeedbackMessages(newFeedbackMessages);
					}

					// If there's a general error detail message
					if (apiErrors.detail) {
						setAlertMessage(apiErrors.detail[0]);
						setShowAlert(true);

						// Hide the alert after 5 seconds
						setTimeout(() => {
							setShowAlert(false);
						}, 10000);
					} else if (
						apiErrors['Il ya erreur'] &&
						apiErrors['Il ya erreur'][0]
					) {
						setAlertMessage(apiErrors['Il ya erreur'][0]);
						setShowAlert(true);

						// Hide the alert after 5 seconds
						setTimeout(() => {
							setShowAlert(false);
						}, 10000);
					}
				} else {
					alert(
						"Une erreur s'est produite lors de la soumission du formulaire."
					);
				}
			}
		}

		setValidated(true);
	};

	return (
		<Form
			className="mb-3"
			noValidate
			validated={validated}
			onSubmit={handleSubmit}
		>
			{showAlert && (
				<Alert variant="danger">
					<ExclamationTriangleFill size={25} className="me-1" />
					{alertMessage}
				</Alert>
			)}
			<Row>
				{/* type */}
				<Col xs={12} className="mb-3">
					<Form.Group className="mb-3">
						<Form.Label htmlFor="type">
							Type <span className="text-danger">*</span>
						</Form.Label>
						<Form.Select
							name="type"
							required
							isInvalid={!!feedbackMessages['type']}
							onChange={(e) => {
								setFeedbackMessages((prevMessages) => ({
									...prevMessages,
									type: e.target.value ? '' : 'Le type est requis.'
								}));
							}}
						>
							{TYPE_CHOICES.map((option, index) => (
								<option key={index} value={option.value}>
									{option.label}
								</option>
							))}
						</Form.Select>
						<Form.Control.Feedback type="invalid">
							{feedbackMessages['type']}
						</Form.Control.Feedback>
					</Form.Group>
				</Col>

				{/* montant */}
				<Col xs={12} className="mb-3">
					<Form.Group className="mb-3">
						<Form.Label htmlFor="montant">Cout</Form.Label>
						<Form.Control
							name="montant"
							type="number"
							placeholder="Saisir le montant "
							id="montant"
							required
							isInvalid={!!feedbackMessages['montant']}
							onChange={(e) => {
								setFeedbackMessages((prevMessages) => ({
									...prevMessages,
									montant: e.target.value ? '' : 'Le montant est requis.'
								}));
							}}
						/>
						<Form.Control.Feedback type="invalid">
							{feedbackMessages['montant']}
						</Form.Control.Feedback>
					</Form.Group>
				</Col>

				{/* date */}
				<Col xs={12} className="mb-3">
					<Form.Group className="mb-3">
						<Form.Label htmlFor="date">
							Date <span className="text-danger">*</span>
						</Form.Label>
						<Form.Control
							name="date"
							type="date"
							placeholder="Saisir une date"
							id="date"
							required
							isInvalid={!!feedbackMessages['date']}
							onChange={(e) => {
								setFeedbackMessages((prevMessages) => ({
									...prevMessages,
									date: e.target.value ? '' : 'La date est requise.'
								}));
							}}
						/>
						<Form.Control.Feedback type="invalid">
							{feedbackMessages['date']}
						</Form.Control.Feedback>
					</Form.Group>
				</Col>

				<Col xs={12} className="mb-3">
					{/* categorie   */}
					<Form.Group>
						<Form.Label htmlFor="categorie">
							Categorie <span className="text-danger">*</span>
						</Form.Label>
						<Form.Control
							name="categorie"
							type="text"
							placeholder="Saisir la categorie du Bilan"
							id="categorie"
							required
							isInvalid={!!feedbackMessages['categorie']}
							onChange={(e) => {
								setFeedbackMessages((prevMessages) => ({
									...prevMessages,
									categorie: e.target.value ? '' : 'La categorie est requis.'
								}));
							}}
						/>
						<Form.Control.Feedback type="invalid">
							{feedbackMessages['categorie']}
						</Form.Control.Feedback>
					</Form.Group>
				</Col>

				{/* description */}
				<Col xs={12} className="mb-3">
					<Form.Group className="mb-3">
						<Form.Label htmlFor="description">
							Description <span className="text-danger">*</span>
						</Form.Label>
						<Form.Control
							name="description"
							as="textarea"
							placeholder="Saisir la description du Bilan"
							id="description"
							required
							isInvalid={!!feedbackMessages['description']}
							onChange={(e) => {
								setFeedbackMessages((prevMessages) => ({
									...prevMessages,
									description: e.target.value
										? ''
										: 'Le description est requis.'
								}));
							}}
						/>
						<Form.Control.Feedback type="invalid">
							{feedbackMessages['description']}
						</Form.Control.Feedback>
					</Form.Group>
				</Col>

				{/* reference */}
				<Col xs={12} className="mb-3">
					<Form.Group className="mb-3">
						<Form.Label htmlFor="reference">
							Reference <span className="text-danger">*</span>
						</Form.Label>
						<Form.Control
							name="reference"
							type="text"
							placeholder="Saisir la reference du Bilan"
							id="reference"
							required
							isInvalid={!!feedbackMessages['reference']}
							onChange={(e) => {
								setFeedbackMessages((prevMessages) => ({
									...prevMessages,
									reference: e.target.value ? '' : 'La reference est requis.'
								}));
							}}
						/>
						<Form.Control.Feedback type="invalid">
							{feedbackMessages['reference']}
						</Form.Control.Feedback>
					</Form.Group>
				</Col>

				{/* personnel */}
				<Col xs={12} className="mb-3">
					<Form.Group className="mb-3">
						<Form.Label htmlFor="personnel">
							Personnel <span className="text-danger">*</span>
						</Form.Label>
						<Form.Select
							name="personnel"
							required
							isInvalid={!!feedbackMessages['personnel']}
							onChange={(e) => {
								setFeedbackMessages((prevMessages) => ({
									...prevMessages,
									personnel: e.target.value ? '' : 'Le personnel est requis.'
								}));
							}}
						>
							{Personnel_CHOICES.map((option, index) => (
								<option key={index} value={option.value}>
									{option.label}
								</option>
							))}
						</Form.Select>
						<Form.Control.Feedback type="invalid">
							{feedbackMessages['personnel']}
						</Form.Control.Feedback>
					</Form.Group>
				</Col>

				<Col xs={12} className="mb-3">
					{/* fournisseur  */}
					<Form.Group>
						<Form.Label htmlFor="fournisseur">
							Fournisseur <span className="text-danger">*</span>
						</Form.Label>
						<Form.Control
							name="fournisseur"
							type="text"
							placeholder="Saisir le fournisseur "
							id="fournisseur"
							required
							isInvalid={!!feedbackMessages['fournisseur']}
							onChange={(e) => {
								setFeedbackMessages((prevMessages) => ({
									...prevMessages,
									fournisseur: e.target.value
										? ''
										: 'Le fournisseur est requis.'
								}));
							}}
						/>
						<Form.Control.Feedback type="invalid">
							{feedbackMessages['fournisseur']}
						</Form.Control.Feedback>
					</Form.Group>
				</Col>

				{/* Buttons */}
				<Col xs={12} className="mt-4">
					<Button variant="success" type="submit">
						Enregistrer
					</Button>
					<Button onClick={onClick} variant="outline-danger" className="ms-2">
						Fermer
					</Button>
				</Col>
			</Row>
		</Form>
	);
};

export default OffcanvasAddDepenserecetteForm;
